import React, { useState, useEffect } from 'react';
import {number, func, bool} from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet, useForm } from '@laramie/ui';
import { Accordion, CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormError, FormLabel, InputEntidad, InputLista, InputNumber, InputPercent, InputPersona, Modal } from '../../common';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {getDateId} from '../../../utils/convert';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";

import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const ControladorModal = (props) => {

    //variables
    const entityInit = {
        controlador: {
            id: 0,
            idTipoControlador: 0,
            numero: '',
            esSupervisor: false,
            fechaAlta: null,
            fechaBaja: null,
            catastralCir: '',
            catastralSec: '',
            catastralChacra: '',
            catastralLchacra: '',
            catastralQuinta: '',
            catastralLquinta: '',
            catastralFrac: '',
            catastralLfrac: '',
            catastralManz: '',
            catastralLmanz: '',
            catastralParc: '',
            catastralLparc: '',
            catastralSubparc: '',
            catastralUfunc: '',
            catastralUcomp: '',
            idPersona: 0,
            idTipoPersona: 0,
            nombrePersona: '',
            idTipoDocumento: 0,
            numeroDocumento: '',
            legajo: '',
            idOrdenamiento: 0,
            idControladorSupervisor: 0,
            clasificacion: '',
            fechaUltimaIntimacion: null,
            cantidadIntimacionesEmitidas: 0,
            cantidadIntimacionesAnuales: 0,
            porcentaje: 0,
            catastralCodigo: '',
            catastralPartido: '',
            abogadoPorDefecto: false
        },
        archivos: [],
        observaciones: [],
        etiquetas: []
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit
    });

    const [persona, setPersona] = useState({
        idTipoPersona: 0,
        nombrePersona: "",
        numeroDocumento: "",
        idTipoDocumento: 0
    });

    const [processKey, setProcessKey] = useState(null);

    //sólo un controlador de un tipo marcado como abogado puede ser el abogado/a por defecto
    const [esAbogado, setEsAbogado] = useState(false);

    const mount = () => {

        const _processKey = `Controlador_${props.id ?? 0}_${getDateId()}`;
        setProcessKey(_processKey);

        if (props.id > 0) {
            FindControlador();
        } else {
            dispatch(dataTaggerActionSet(_processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
        }

        const unmount = () => {
        }
        return unmount;
    }
    useEffect(mount, []);

    useEffect(() => {
        if (processKey && state.entity.controlador.id > 0) {
            dispatch(dataTaggerActionSet(processKey, {
                Archivo: state.entity.archivos,
                Observacion: state.entity.observaciones,
                Etiqueta: state.entity.etiquetas
            }));
        }
    }, [processKey, state.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoControlador: 0,
        numero: '',
        esSupervisor: false,
        fechaAlta: null,
        fechaBaja: null,
        catastralCir: '',
        catastralSec: '',
        catastralChacra: '',
        catastralLchacra: '',
        catastralQuinta: '',
        catastralLquinta: '',
        catastralFrac: '',
        catastralLfrac: '',
        catastralManz: '',
        catastralLmanz: '',
        catastralParc: '',
        catastralLparc: '',
        catastralSubparc: '',
        catastralUfunc: '',
        catastralUcomp: '',
        idPersona: 0,
        legajo: '',
        idOrdenamiento: 0,
        idControladorSupervisor: 0,
        clasificacion: '',
        fechaUltimaIntimacion: null,
        cantidadIntimacionesEmitidas: 0,
        cantidadIntimacionesAnuales: 0,
        porcentaje: 0,
        catastralCodigo: '',
        catastralPartido: '',
        abogadoPorDefecto: false
    });

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    //handles
    const [administrativosOpen, setAdministrativosOpen] = useState(false);

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAceptar = () => {
        const errors = getErrors();
        if (errors.numero || errors.fechaAlta) setAdministrativosOpen(true);

        if (validate()) {
            if (props.id === 0) {
                AddControlador();
            } else {
                ModifyControlador();
            }
        }
        ;
    };
    const handleClickCancelar = () => {
        dispatch(dataTaggerActionClear(processKey));
        props.onDismiss();
    }

    const handleChangeTipoControlador = (event) => {
        const {target} = event;
        let idTipoControlador = 0;
        let esSupervisor = false;
        let abogado = false;
        if (target.row) {
            idTipoControlador = parseInt(target.value);
            esSupervisor = target.row.esSupervisor;
            abogado = target.row.abogado === true;
        }

        setEsAbogado(abogado);
        formSet({
            ...formValues,
            idTipoControlador: idTipoControlador,
            esSupervisor: esSupervisor,
            abogadoPorDefecto: abogado && formValues.abogadoPorDefecto
        });
    };

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoControlador <= 0) errors.idTipoControlador = VALIDATION_MESSAGE.REQUIRED_OPTION
        if (formValues.numero.length === 0) errors.numero = VALIDATION_MESSAGE.REQUIRED
        if (formValues.fechaAlta === null) errors.fechaAlta = VALIDATION_MESSAGE.REQUIRED_DATE
        if (formValues.idPersona <= 0) errors.idPersona = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors;
    }

    function FindControlador() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    if (data.controlador.fechaAlta) data.controlador.fechaAlta = new Date(data.controlador.fechaAlta);
                    if (data.controlador.fechaBaja) data.controlador.fechaBaja = new Date(data.controlador.fechaBaja);
                    if (data.controlador.fechaUltimaIntimacion) data.controlador.fechaUltimaIntimacion = new Date(data.controlador.fechaUltimaIntimacion);
                    data.archivos.forEach(x => {
                        if (x.fecha) x.fecha = new Date(x.fecha);
                    });
                    data.observaciones.forEach(x => {
                        if (x.fecha) x.fecha = new Date(x.fecha);
                    });

                    setState(prevState => {
                        return {...prevState, loading: false, entity: data};
                    });
                    formSet({
                        idTipoControlador: data.controlador.idTipoControlador,
                        numero: data.controlador.numero,
                        esSupervisor: data.controlador.esSupervisor,
                        fechaAlta: data.controlador.fechaAlta,
                        fechaBaja: data.controlador.fechaBaja,
                        catastralCir: data.controlador.catastralCir,
                        catastralSec: data.controlador.catastralSec,
                        catastralChacra: data.controlador.catastralChacra,
                        catastralLchacra: data.controlador.catastralLchacra,
                        catastralQuinta: data.controlador.catastralQuinta,
                        catastralLquinta: data.controlador.catastralLquinta,
                        catastralFrac: data.controlador.catastralFrac,
                        catastralLfrac: data.controlador.catastralLfrac,
                        catastralManz: data.controlador.catastralManz,
                        catastralLmanz: data.controlador.catastralLmanz,
                        catastralParc: data.controlador.catastralParc,
                        catastralLparc: data.controlador.catastralLparc,
                        catastralSubparc: data.controlador.catastralSubparc,
                        catastralUfunc: data.controlador.catastralUfunc,
                        catastralUcomp: data.controlador.catastralUcomp,
                        idPersona: data.controlador.idPersona,
                        legajo: data.controlador.legajo,
                        idOrdenamiento: data.controlador.idOrdenamiento,
                        idControladorSupervisor: data.controlador.idControladorSupervisor,
                        clasificacion: data.controlador.clasificacion,
                        fechaUltimaIntimacion: data.controlador.fechaUltimaIntimacion,
                        cantidadIntimacionesEmitidas: data.controlador.cantidadIntimacionesEmitidas,
                        cantidadIntimacionesAnuales: data.controlador.cantidadIntimacionesAnuales,
                        porcentaje: data.controlador.porcentaje,
                        catastralCodigo: data.controlador.catastralCodigo,
                        catastralPartido: data.controlador.catastralPartido,
                        abogadoPorDefecto: data.controlador.abogadoPorDefecto ?? false
                    });
                    setEsAbogado(data.controlador.tipoControlador?.abogado ?? false);
                    setPersona({
                        idTipoPersona: data.controlador.idTipoPersona,
                        nombrePersona: data.controlador.nombrePersona,
                        numeroDocumento: data.controlador.numeroDocumento,
                        idTipoDocumento: data.controlador.idTipoDocumento
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/${props.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CONTROLADOR,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddControlador() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveControlador(method, paramsUrl);
    }

    function ModifyControlador() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveControlador(method, paramsUrl);
    }

    function SaveControlador(method, paramsUrl) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                    dispatch(dataTaggerActionClear(processKey));
                    props.onConfirm(row.id);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            controlador: {
                ...state.entity.controlador,
                idTipoControlador: parseInt(formValues.idTipoControlador),
                numero: formValues.numero,
                esSupervisor: formValues.esSupervisor,
                fechaAlta: formValues.fechaAlta,
                fechaBaja: formValues.fechaBaja,
                catastralCir: formValues.catastralCir,
                catastralSec: formValues.catastralSec,
                catastralChacra: formValues.catastralChacra,
                catastralLchacra: formValues.catastralLchacra,
                catastralQuinta: formValues.catastralQuinta,
                catastralLquinta: formValues.catastralLquinta,
                catastralFrac: formValues.catastralFrac,
                catastralLfrac: formValues.catastralLfrac,
                catastralManz: formValues.catastralManz,
                catastralLmanz: formValues.catastralLmanz,
                catastralParc: formValues.catastralParc,
                catastralLparc: formValues.catastralLparc,
                catastralSubparc: formValues.catastralSubparc,
                catastralUfunc: formValues.catastralUfunc,
                catastralUcomp: formValues.catastralUcomp,
                idPersona: parseInt(formValues.idPersona),
                idTipoPersona: parseInt(persona.idTipoPersona),
                nombrePersona: persona.nombrePersona,
                idTipoDocumento: parseInt(persona.idTipoDocumento),
                numeroDocumento: persona.numeroDocumento,
                legajo: formValues.legajo,
                idOrdenamiento: parseInt(formValues.idOrdenamiento),
                idControladorSupervisor: parseInt(formValues.idControladorSupervisor),
                clasificacion: formValues.clasificacion,
                fechaUltimaIntimacion: formValues.fechaUltimaIntimacion,
                cantidadIntimacionesEmitidas: formValues.cantidadIntimacionesEmitidas,
                cantidadIntimacionesAnuales: formValues.cantidadIntimacionesAnuales,
                porcentaje: formValues.porcentaje,
                catastralCodigo: formValues.catastralCodigo,
                catastralPartido: formValues.catastralPartido,
                abogadoPorDefecto: esAbogado && formValues.abogadoPorDefecto
            },
            archivos: (dataTagger[processKey]) ? dataTagger[processKey].Archivo.filter(f => f.state !== 'o') : [],
            observaciones: (dataTagger[processKey]) ? dataTagger[processKey].Observacion.filter(f => f.state !== 'o') : [],
            etiquetas: (dataTagger[processKey]) ? dataTagger[processKey].Etiqueta.filter(f => f.state !== 'o') : []
        };

        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.CONTROLADOR,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <Modal
            size="lg"
            title={`Controlador: ${(props && props.id > 0) ? state.entity.controlador.numero : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">

                                <div className="col-12">
                                    <FormLabel htmlFor="idPersona" required>Apellido y nombre del
                                        controlador/a</FormLabel>
                                    <InputPersona
                                        name="idPersona"
                                        placeholder=""
                                        className={`form-control ${errorOf('idPersona') ? 'is-invalid' : ''}`}
                                        value={formValues.idPersona}
                                        idTipoPersona={0}
                                        onChange={(event) => {
                                            const {target} = event;
                                            const persona = (target.row) ? {
                                                idTipoPersona: target.row.idTipoPersona,
                                                idTipoDocumento: target.row.idTipoDocumento,
                                                numeroDocumento: target.row.numeroDocumento,
                                                nombrePersona: target.row.nombrePersona
                                            } : {
                                                idTipoPersona: 0,
                                                idTipoDocumento: 0,
                                                numeroDocumento: "",
                                                nombrePersona: ""
                                            };
                                            setPersona(persona);
                                            formHandle(event);
                                        }}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('idPersona')} />
                                </div>
                                <div className="mb-3 col-8 p-top-10">
                                    <FormLabel htmlFor="idTipoControlador" required>Tipo de
                                        controlador</FormLabel>
                                    <InputEntidad
                                        name="idTipoControlador"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoControlador') ? 'is-invalid' : ''}`}
                                        onChange={handleChangeTipoControlador}
                                        value={formValues.idTipoControlador}
                                        disabled={props.disabled}
                                        title="Tipo controlador"
                                        entidad="TipoControlador"
                                        onFormat={(row) => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                    />
                                    <FormError message={errorOf('idTipoControlador')} />
                                </div>
                                <div className="mb-3 col-4">
                                    <CheckboxButtonGroup label="Rol">
                                        <CheckboxButton
                                            name="esSupervisor"
                                            label="Supervisor/a"
                                            checked={formValues.esSupervisor}
                                            onChange={formHandle}
                                            disabled={true}
                                        />
                                        <CheckboxButton
                                            name="abogadoPorDefecto"
                                            label="Abogado/a por defecto"
                                            checked={formValues.abogadoPorDefecto}
                                            onChange={formHandle}
                                            disabled={props.disabled || !esAbogado}
                                        />
                                    </CheckboxButtonGroup>
                                </div>
                                {/*
                    <div className="mb-3 col-12 col-md-4">
                        <label htmlFor="numero" className="form-label">Número</label>
                        <input
                            name="numero"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.numero }
                            onChange={ formHandle }
                            disabled={props.disabled}
                        />
                    </div>
                    <div className="mb-3 col-6 col-md-4">
                        <label htmlFor="fechaAlta" className="form-label">Fecha alta</label>
                        <DatePickerCustom
                            name="fechaAlta"
                            placeholder=""
                            className="form-control"
                            value={ formValues.fechaAlta }
                            onChange={ formHandle }
                            disabled={props.disabled}
                        />
                    </div>
                    <div className="mb-3 col-6 col-md-4">
                        <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                        <DatePickerCustom
                            name="fechaBaja"
                            placeholder=""
                            className="form-control"
                            value={ formValues.fechaBaja }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            minValue={formValues.fechaAlta}
                        />
                    </div>
*/}
                                <div className="mb-3 col-12">
                                    <Accordion title="Nomenclatura catastral" startOpen={true}>
                                            <div className='row form-basic'>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralPartido"
                                                           className="form-label">Partido</label>
                                                    <input
                                                        name="catastralPartido"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralPartido}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralCir" className="form-label">Circ.</label>
                                                    <input
                                                        name="catastralCir"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralCir}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralSec" className="form-label">Sec.</label>
                                                    <input
                                                        name="catastralSec"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralSec}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralCodigo"
                                                           className="form-label">Código</label>
                                                    <input
                                                        name="catastralCodigo"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralCodigo}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralChacra"
                                                           className="form-label">Chacra</label>
                                                    <input
                                                        name="catastralChacra"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralChacra}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralLchacra" className="form-label">L.
                                                        Chacra</label>
                                                    <input
                                                        name="catastralLchacra"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLchacra}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralQuinta"
                                                           className="form-label">Quinta</label>
                                                    <input
                                                        name="catastralQuinta"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralQuinta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralLquinta" className="form-label">L.
                                                        Quinta</label>
                                                    <input
                                                        name="catastralLquinta"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLquinta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralFrac" className="form-label">Frac.</label>
                                                    <input
                                                        name="catastralFrac"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralFrac}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralLfrac" className="form-label">L.
                                                        Frac.</label>
                                                    <input
                                                        name="catastralLfrac"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLfrac}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralManz" className="form-label">Manz.</label>
                                                    <input
                                                        name="catastralManz"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralManz}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralLmanz" className="form-label">L.
                                                        Manz.</label>
                                                    <input
                                                        name="catastralLmanz"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLmanz}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralParc" className="form-label">Parc.</label>
                                                    <input
                                                        name="catastralParc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralParc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralLparc" className="form-label">L.
                                                        Parc.</label>
                                                    <input
                                                        name="catastralLparc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralLparc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralSubparc"
                                                           className="form-label">SubParc.</label>
                                                    <input
                                                        name="catastralSubparc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralSubparc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralUfunc"
                                                           className="form-label">U.Func.</label>
                                                    <input
                                                        name="catastralUfunc"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralUfunc}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="catastralUcomp"
                                                           className="form-label">U.Comp</label>
                                                    <input
                                                        name="catastralUcomp"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.catastralUcomp}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>

                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Datos administrativos" open={administrativosOpen} onToggle={setAdministrativosOpen}>
                                            <div className='row form-basic'>
                                                <div className="col-12">
                                                    <label htmlFor="idControladorSupervisor" className="form-label">Apellido
                                                        y nombre del supervisor/a</label>
                                                    <InputEntidad
                                                        name="idControladorSupervisor"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.idControladorSupervisor}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Supervisor"
                                                        entidad="Controlador"
                                                        onFormat={(row) => (row && row.id) ? `${row.nombrePersona} (Legajo: ${row.legajo})` : ''}
                                                        filter={(row) => {
                                                            return row.esSupervisor;
                                                        }}
                                                        columns={[
                                                            {Header: 'Legajo', accessor: 'legajo', width: '25%'},
                                                            {
                                                                Header: 'Nombre y apellido',
                                                                accessor: 'nombrePersona',
                                                                width: '70%'
                                                            }
                                                        ]}
                                                        memo={false}
                                                    />
                                                </div>
                                                {/*
                                                <div className="col-12">
                                                    <label htmlFor="idPersona" className="form-label">Apellido y nombre</label>
                                                    <InputPersona
                                                        name="idPersona"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={ formValues.idPersona }
                                                        idTipoPersona={0}
                                                        onChange={(event) => {
                                                            const {target} = event;
                                                            const persona = (target.row) ? {
                                                              idTipoPersona: target.row.idTipoPersona,
                                                              idTipoDocumento: target.row.idTipoDocumento,
                                                              numeroDocumento: target.row.numeroDocumento,
                                                              nombrePersona: target.row.nombrePersona
                                                            } : {
                                                              idTipoPersona: 0,
                                                              idTipoDocumento: 0,
                                                              numeroDocumento: "",
                                                              nombrePersona: ""
                                                            };
                                                            setPersona(persona);
                                                            formHandle(event);
                                                          }}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                */}
                                                <div className="col-12 col-md-6">
                                                    <label htmlFor="legajo"
                                                           className="form-label">Legajo/Matrícula</label>
                                                    <input
                                                        name="legajo"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.legajo}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label htmlFor="idOrdenamiento"
                                                           className="form-label">Ordenamiento</label>
                                                    <InputLista
                                                        name="idOrdenamiento"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.idOrdenamiento}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        lista="Ordenamiento"
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <FormLabel htmlFor="numero" required>Número</FormLabel>
                                                    <input
                                                        name="numero"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('numero') ? 'is-invalid' : ''}`}
                                                        value={formValues.numero}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('numero')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <FormLabel htmlFor="fechaAlta" required>Fecha alta</FormLabel>
                                                    <DatePickerCustom
                                                        name="fechaAlta"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                        value={formValues.fechaAlta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('fechaAlta')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaBaja}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        minValue={formValues.fechaAlta}
                                                    />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>
                                {/*
                                <div className="mb-3 col-12">
                                    <div className='accordion-header'>
                                        <div className='row'>
                                            <div className="col-12" onClick={() => ToggleAccordion('datosSupervisor')}>
                                                <div className='accordion-header-title'>
                                                    {(state.accordions.datosSupervisor) ? accordionOpen : accordionClose}
                                                    <h3 className={state.accordions.datosSupervisor ? 'active' : ''}>Datos del supervisor</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(state.accordions.datosSupervisor &&
                                    <div className='accordion-body'>
                                        <div className='row form-basic'>
                                            <div className="col-12">
                                                <label htmlFor="idControladorSupervisor" className="form-label">Apellido y nombre del supervisor</label>
                                                <InputEntidad
                                                    name="idControladorSupervisor"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={ formValues.idControladorSupervisor }
                                                    onChange={ formHandle }
                                                    disabled={props.disabled}
                                                    title="Supervisor"
                                                    entidad="Controlador"
                                                    onFormat={(row) => (row && row.id) ? `${row.nombrePersona} (Legajo: ${row.legajo})` : ''}
                                                    filter={(row) => { return row.esSupervisor; }}
                                                    columns={[
                                                        { Header: 'Legajo', accessor: 'legajo', width: '25%' },
                                                        { Header: 'Nombre y apellido', accessor: 'nombrePersona', width: '70%' }
                                                    ]}
                                                    memo={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                */}
                                <div className="mb-3 col-12">
                                    <Accordion title="Intimaciones">
                                            <div className='row form-basic'>

                                                <div className="mb-3 col-12 col-md-8">
                                                    <label htmlFor="clasificacion"
                                                           className="form-label">Clasificación</label>
                                                    <input
                                                        name="clasificacion"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.clasificacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="fechaUltimaIntimacion" className="form-label">Última
                                                        intimación</label>
                                                    <DatePickerCustom
                                                        name="fechaUltimaIntimacion"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaUltimaIntimacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="cantidadIntimacionesEmitidas"
                                                           className="form-label m-left-10">Cant. Intimaciones
                                                        emitidas</label>
                                                    <InputNumber
                                                        name="cantidadIntimacionesEmitidas"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.cantidadIntimacionesEmitidas}
                                                        precision={0}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="cantidadIntimacionesAnuales"
                                                           className="form-label m-left-10">Cant. Intimaciones
                                                        anuales</label>
                                                    <InputNumber
                                                        name="cantidadIntimacionesAnuales"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.cantidadIntimacionesAnuales}
                                                        precision={0}
                                                        onChange={formHandle}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <label htmlFor="porcentaje" className="form-label m-left-10">Porcentaje</label>
                                                    <InputPercent
                                                        name="porcentaje"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.porcentaje}
                                                        onChange={formHandle}
                                                        disabled={true}
                                                    />
                                                </div>

                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                            <DataTaggerFormRedux
                                                title="Información adicional de Controlador"
                                                processKey={processKey}
                                                entidad="Controlador"
                                                idEntidad={props.id}
                                                disabled={props.disabled}
                                            />
                                    </Accordion>
                                </div>

                            </div>
            )}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickCancelar()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

ControladorModal.propTypes = {
    disabled: bool,
    id: number.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ControladorModal.defaultProps = {
    disabled: false
};

export default ControladorModal;